import memoizeOne from "memoize-one";
import { roundValue, safeParseFloat } from "lib/number";
import { loopNestedChildren } from "./ag-grid-helper";
import { MergedColumnFormulaOptions } from "./types";
import { TOTAL_COST as formulaTotalCost } from "../formulas/formula-total-cost";

/**
 * Loop through row group children and recompute TOTAL_COST value.
 * This is very useful when we can't re-use computed values because TOTAL_COST metrics is not turned on, thus, the column doesn't exist.
 * @param factoryOptions
 * @param getterParams
 * @returns
 */
export const getChildrenTotalCost = memoizeOne(
    (factoryOptions, getterParams) => {
        let sumValue = 0;
        const { node } = getterParams;
        loopNestedChildren(node, (childNode) => {
            const value = formulaTotalCost({
                factoryOptions,
                getterParams: {
                    ...getterParams,
                    node: childNode,
                    data: childNode.data,
                },
            });

            sumValue += +(value ?? 0);
        });

        return sumValue;
    },
    (newArgs, oldArgs) =>
        newArgs[1].colDef.colId === oldArgs[1].colDef.colId && newArgs[1].node.id === oldArgs[1].node.id
);

/**
 * All this function does is summing values from children rows. Therefore, there is no need to multiply units by cost price
 */
export const TOTAL_COST = (values: number[], options: MergedColumnFormulaOptions) => {
    return roundValue(
        values.reduce((acc, value) => acc + safeParseFloat(value, 0), 0),
        options.decimal
    );
};
